module.exports = __webpack_public_path__ + "img/ИФ-1(А)-004.5f0ba7e6.png";